const fahrenheitToCelsius = (fahrenheit: number): string => {
  const celsius = ((fahrenheit - 32) / 1.8);
  return String(Math.round(celsius));
}

export default fahrenheitToCelsius;
